import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Button, Modal } from '@salesforce/design-system-react';

import './ArchiveFallbackModal.scss';

class ArchiveFallbackModal extends Component {
  constructor(props) {
    super(props);
    this.modalName = 'archiveFallback';
  }

  modalData() {
    return this.props.modals[this.modalName]?.data || {};
  }

  getI18nID(suffix) {
    return `components.ecs.assetBrowser.archiveFallbackModal.${suffix}`;
  }

  // ===================================
  // =         Event Handlers          =
  // ===================================
  handleSave() {
    if (this.modalData()?.action === 'archive') {
      this.props.actions.archiveAsset(this.modalData()?.asset, 'browser', {
        cToken: this.props.session.cToken
      });
    } else if (this.modalData()?.action === 'disable') {
      const asset = this.modalData()?.asset || {};
      asset['availability'] = 'N';
      this.props.actions.editAsset(asset, {
        callback: () => {
          // don't have to worry about new/parent old parent since this is just
          // toggling availability
          if (asset.parent_id) {
            // refresh the parent
            this.props.actions.refreshAsset(asset.parent_id, {
              context: 'browser'
            });
          }
        },
        context: 'browser',
        cToken: this.props.session.cToken
      });
    } else if (this.modalData()?.action === 'assetClass') {
      this.props.actions.archiveAssetClass(this.modalData()?.assetClass, {
        cToken: this.props.session.cToken
      });
    }
    this.closeModal();
  }

  // ===================================
  // =           Actions               =
  // ===================================
  closeModal() {
    this.props.actions.closeModal(this.modalName);
  }

  // ===================================
  // =           Rendering             =
  // ===================================
  renderFooter() {
    const { formatMessage } = this.props.intl;
    /**
     * Cancel
     */
    const cancelLabel = formatMessage({
      id: this.getI18nID('buttons.cancel')
    });
    const cancelButton = (
      <Button
        label={cancelLabel}
        variant="neutral"
        onClick={this.closeModal.bind(this)}
      />
    );

    /**
     * Save
     */
    const saveLabel =
      this.modalData()?.action === 'assetClass'
        ? formatMessage({ id: 'components.ecs.classes.archive.warning.ok' })
        : formatMessage({ id: this.getI18nID('buttons.save') });
    const saveButton = (
      <Button
        id="assetSaveButton"
        label={saveLabel}
        variant="brand"
        onClick={this.handleSave.bind(this)}
      />
    );

    return (
      <div className="footer-button-actions">
        {cancelButton}
        {saveButton}
      </div>
    );
  }

  renderArchiveFallBack() {
    const description =
      this.modalData()?.action === 'assetClass'
        ? 'components.ecs.classes.archive.warning.body'
        : this.getI18nID('description');
    return (
      <div className="slds-card-wrapper">
        <div className="slds-grid">
          <div className="archive-fallback-description">
            <FormattedMessage id={description} />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const isOpen =
      this.props.modals[this.modalName] &&
      this.props.modals[this.modalName].isOpen;
    const modalTitle =
      this.modalData()?.action === 'assetClass'
        ? formatMessage({ id: 'components.ecs.classes.archive.warning.title' })
        : formatMessage({ id: this.getI18nID('title') });
    if (!isOpen) {
      return null;
    }

    return (
      <Modal
        className="archive-fallback"
        heading={modalTitle}
        footer={this.renderFooter()}
        onRequestClose={this.closeModal.bind(this)}
        dismissOnClickOutside={false}
        isOpen={isOpen || false}
        prompt="warning"
      >
        {this.renderArchiveFallBack()}
      </Modal>
    );
  }
}

ArchiveFallbackModal.propTypes = {
  actions: PropTypes.object.isRequired,
  modals: PropTypes.object.isRequired,
  session: PropTypes.object
};

export default injectIntl(ArchiveFallbackModal);
